/**
 * Fiskal Cloud Notification API
 * # Changelog ## 1.0.0 * Initial Admin API 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagingDTO } from './paging-dto';
import { EmailNotificationDTO } from './email-notification-dto';


/**
 * Response with notifications and paging
 */
export interface EmailNotificationsResponseDTO { 
    /**
     * Array of notifications
     */
    results?: Array<EmailNotificationDTO>;
    paging?: PagingDTO;
}

export class ClsEmailNotificationsResponseDTO { 
    /**
     * Array of notifications
     */
    results?: Array<EmailNotificationDTO> = undefined;
    paging?: PagingDTO = undefined;
}

